var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.992305 15.383C2.7636 12.9852 6.20482 9.0723 11.316 6.45511L15.9489 11.0881C14.3307 12.7411 13.3332 15.0041 13.3332 17.5C13.3332 22.5625 17.4373 26.6667 22.4998 26.6667C24.9959 26.6667 27.2589 25.6691 28.9119 24.051L33.4993 28.6384C30.4269 30.1807 26.7604 31.25 22.4998 31.25C11.0105 31.25 3.84133 23.4737 0.992305 19.617C0.0513929 18.3433 0.0513929 16.6567 0.992305 15.383ZM30.8992 21.177L36.5582 26.836C40.1085 24.4188 42.5915 21.5338 44.0073 19.617C44.9483 18.3433 44.9483 16.6567 44.0073 15.383C41.1583 11.5263 33.9893 3.75 22.4998 3.75C19.6444 3.75 17.0556 4.23036 14.7337 5.01152L18.8228 9.10063C19.9485 8.60716 21.1922 8.33333 22.4998 8.33333C27.5625 8.33333 31.6664 12.4374 31.6664 17.5C31.6664 18.8076 31.3926 20.0515 30.8992 21.177Z",
    fill: "#1B234E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10071 0.815905C6.4295 0.144698 5.34124 0.144698 4.67003 0.815905C3.99882 1.48711 3.99882 2.57538 4.67003 3.24658L14.3442 12.9208C14.9943 11.9658 15.82 11.1401 16.7749 10.4901L7.10071 0.815905ZM29.5099 23.225C28.8598 24.18 28.0341 25.0057 27.0792 25.6558L36.7534 35.3298C37.4247 36.0011 38.5127 36.0011 39.184 35.3298C39.8552 34.6586 39.8552 33.5705 39.184 32.8993L29.5099 23.225Z",
    fill: "#1B234E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.0834C25.0313 22.0834 27.0833 20.0315 27.0833 17.5001C27.0833 14.9687 25.0313 12.9167 22.5 12.9167C19.9686 12.9167 17.9166 14.9687 17.9166 17.5001C17.9166 20.0315 19.9686 22.0834 22.5 22.0834Z",
    fill: "#1B234E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/iconEye.8165b8ec6effb4067b1dc2b1c6fcbef7.svg";
export { ForwardRef as ReactComponent };